export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.f60b16c8.ttf";